import { TableRow } from '@mui/material';
import { Fragment } from 'react';

const BSTableRow = ({ children, subContent, ...props }) => {
  return (
    <Fragment>
      <TableRow
        sx={{
          '& > *': { borderBottom: 'unset' },
          backgroundColor: (theme) => theme.palette.background.paper
        }}>
        {children}
      </TableRow>
    </Fragment>
  );
};

export default BSTableRow;
